import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import type { FieldArrayWithId } from "react-hook-form"

import type { AddPalletsAdjustmentFormValues } from "../../schemas"

import { AddPalletsAdjustmentDestinationFieldSet } from "./AddPalletsAdjustmentDestinationFieldSet"

import type { WarehouseArea } from "@/graphql/codegen/graphql"

interface AddPalletsAdjustmentFormDestinationsProps {
  warehouseArea?: WarehouseArea | null
  destinationFields: FieldArrayWithId<AddPalletsAdjustmentFormValues, "destinations">[]
  selectedShelvingIds: string[]
}

export const AddPalletsAdjustmentFormDestinations: FC<AddPalletsAdjustmentFormDestinationsProps> = ({
  warehouseArea,
  destinationFields,
  selectedShelvingIds,
}) => {
  return (
    <Box className='flex min-h-0 flex-1 flex-col rounded-lg border border-gray-400'>
      <Typography variant='h6' className='p-4 font-bold leading-10'>
        2. Define Pallet Destinations
      </Typography>
      <Box className='flex flex-col gap-6 overflow-y-auto px-4 pb-4'>
        {destinationFields.map((field, index) => (
          <AddPalletsAdjustmentDestinationFieldSet
            key={field.id}
            index={index}
            warehouseArea={warehouseArea}
            selectedShelvingIds={selectedShelvingIds}
          />
        ))}
      </Box>
    </Box>
  )
}
